module.exports = __webpack_public_path__ + "static/media/card-blue-background.b615ba0e.svg";